export const versionSearch = /^\d+(?:\.\d+)*$/;
